import React, { FC } from 'react';

import { AllieCard, AllieLink, AllieText } from '../../../components';
import {
  FlexContainer,
  StationSummaryStyled,
  StyledStationButton,
  StyledStationTitleLink,
} from './StationListSummaryCard.styles';
import {
  AllieProductionOrderStatusChip,
  ProductionOrderStatus,
} from '../ProductionOrderStatusChip/ProductionOrderStatusChip';
import { ProgressContainer } from './components/ProgressContainer';
import { Stats } from './components/Stats';
import { POField } from './components/POField';
import { ShiftField } from './components/ShiftField';
import { OEEContainer } from './components/OEEContainer';
import { StationSummaryCardProps } from './StationSummaryCard.types';

const mapProductionStatusBorderColor: Record<string, string> = {
  in_progress: 'none',
  stopped: 'var(--allie-color-error-main)',
  paused: 'none',
  no_productions: 'none',
  technical_stop: 'none',
};

export const AllieStationListSummaryCard: FC<StationSummaryCardProps> = ({
  title,
  data,
  barData,
  labels,
  onClick,
  className,
  isProductive,
  lastSectionType,
  production,
  OEE,
  statusLabel,
  shiftEndsAt,
  shiftName,
  shiftStartsAt,
  href,
  isTablet = false,
  trackingOnClickEvent,
}) => {
  const isTechnicalStop =
    lastSectionType === 'neutral' && production.status === ProductionOrderStatus.STOPPED;
  return (
    <StationSummaryStyled className={className}>
      <AllieCard
        style={{
          borderRadius: '4px',
          padding: isTablet ? 16 : '16px 20px',
          boxSizing: 'border-box',
          // eslint-disable-next-line max-len
          border: `1px solid ${production.status === 'stopped' ? `${isTechnicalStop ? mapProductionStatusBorderColor[ProductionOrderStatus.TECHNICAL_STOP] : mapProductionStatusBorderColor[production.status]}` : 'var(--allie-color-neutral-20)'}`,
        }}
        content={{
          style: { padding: 0 },
          children: (
            <FlexContainer gap={isTablet ? 16 : 24}>
              <FlexContainer
                flexDirection="column"
                gap={11}
                style={{ width: isTablet ? '100%' : '60%' }}
              >
                <FlexContainer
                  gap={13}
                  alignItems="center"
                  justifyContent={isTablet ? 'space-between' : ''}
                >
                  <StyledStationTitleLink
                    onClick={() => {
                      trackingOnClickEvent && trackingOnClickEvent('Station Name', title);
                      onClick();
                    }}
                    // href={href}
                    isTablet={isTablet}
                  >
                    {title}
                  </StyledStationTitleLink>
                  <AllieProductionOrderStatusChip
                    status={
                      isTechnicalStop ? ProductionOrderStatus.TECHNICAL_STOP : production.status
                    }
                    statusLabel={statusLabel}
                  />
                </FlexContainer>
                {isTablet && (
                  <>
                    <FlexContainer justifyContent="space-between">
                      <POField label={labels.productionOrder} id={production.legacyId} />
                      <ShiftField shiftName={shiftName} />
                    </FlexContainer>

                    <Stats data={data} layout="list" isTablet={isTablet} />
                  </>
                )}
                <ProgressContainer
                  barData={barData}
                  shiftEndsAt={shiftEndsAt}
                  shiftStartsAt={shiftStartsAt}
                  progressBarHeight="100%"
                />
              </FlexContainer>
              {!isTablet && (
                <FlexContainer flexDirection="column" gap={16} style={{ flexGrow: 1 }}>
                  <FlexContainer alignItems="center" justifyContent="space-between">
                    <FlexContainer flexDirection="column" style={{ flexGrow: 1 }}>
                      <FlexContainer
                        gap={10}
                        justifyContent="space-between"
                        alignItems="center"
                        style={{ height: isTablet ? '48px' : '32px', margin: '4px 2px' }}
                      >
                        <POField label={labels.productionOrder} id={production.legacyId} />
                        <ShiftField shiftName={shiftName} />
                      </FlexContainer>

                      {!isTablet && <Stats data={data} layout="list" />}
                    </FlexContainer>
                  </FlexContainer>
                </FlexContainer>
              )}
              <FlexContainer gap={24}>
                <div>
                  <FlexContainer
                    flexDirection="column"
                    alignItems="center"
                    gap={13}
                    style={{
                      width: isTablet ? '100%' : 'unset',
                      height: isTablet ? '100%' : 'unset',
                    }}
                  >
                    <StyledStationButton
                      type="button"
                      allieType="secondary"
                      allieColor="neutral"
                      fill="outline"
                      allieSize={isTablet ? 'medium' : 'xs'}
                      style={{ height: 'unset' }}
                      full
                      className="see-detail"
                      onClick={() => {
                        onClick();
                        trackingOnClickEvent &&
                          trackingOnClickEvent('View more detail button', title);
                      }}
                    >
                      {labels.button}
                    </StyledStationButton>
                    <OEEContainer value={OEE} isTablet={isTablet} />
                  </FlexContainer>
                </div>
              </FlexContainer>
            </FlexContainer>
          ),
        }}
      />
    </StationSummaryStyled>
  );
};
